import { useQuery } from 'react-query';
import { SoilProfileSet } from '../types/types';
import LandscanService from './landscanService';

export const useGetFieldProfileSets = (fieldId: number, year?: number) => {
  return useQuery<SoilProfileSet[]>(
    ['profile-set', { fieldId, year }], () => LandscanService.getFieldProfileSets(fieldId, year)
  );
}

